import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const max = (max: number): ValidatorFn => {
  const key = 'max';

  return (control: AbstractControl): ValidationErrors | null => {
    const value: number = +control.value;

    if (!value) return null;

    if (value > max)
      return {
        [key]: { actualValue: value, requiredValue: max, max: true },
      };

    return null;
  };
};
